import posthog from 'posthog-js'
import type { User } from '@/types/user'

export function identifyPosthogUser(
  user: User | null | undefined,
  role?: string | null
) {
  if (!import.meta.env.VITE_POSTHOG_KEY || !user?.id) return
  const resolvedRole = role ?? user.role ?? undefined
  posthog.identify(String(user.id), {
    email: user.email,
    ...(resolvedRole ? { role: resolvedRole } : {}),
  })
}

export function resetPosthog() {
  if (!import.meta.env.VITE_POSTHOG_KEY) return
  posthog.reset()
}
